import { useState } from 'react'
import { Download } from 'lucide-react'
import { downloadAttachment } from '../lib/download'

/**
 * Download control for an attachment, shared by the task Files tab and the
 * client Knowledge tabs.
 *
 * A button rather than `<a href download>` on purpose: a link click is a
 * navigation request, which Cloudflare's SPA asset router answers with
 * index.html before the Worker runs — see the note in app/lib/download.ts.
 * The fetch also lets a failed download show as an error instead of quietly
 * saving the wrong bytes.
 */
export function DownloadButton({
  url,
  filename,
  size = 14,
}: {
  url: string
  filename: string
  size?: number
}) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return (
    <button
      className="btn-icon"
      type="button"
      disabled={busy}
      aria-label={`Download ${filename}`}
      title={error ?? 'Download'}
      onClick={async () => {
        setBusy(true)
        setError(null)
        try {
          await downloadAttachment(url, filename)
        } catch (err) {
          setError(err instanceof Error ? err.message : 'Download failed')
        } finally {
          setBusy(false)
        }
      }}
    >
      <Download size={size} className={error ? 'text-danger' : undefined} />
    </button>
  )
}
